import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Flex, View } from "@adobe/react-spectrum";
import "./style.css";
import ChatDefaultPage from "../ChatPage/ChatDefaultPage/ChatDefaultPage";
import ChatList from "../ChatPage/ChatList/ChatList";
import ChatFooter from "../ChatPage/ChatFooter/ChatFooter";
import ChatHeader from "../ChatPage/ChatHeader/ChatHeader";
import ChatTranscript from "../ChatPage/ChatTranscript/ChatTranscript";
import { RootState } from "../../store/storeConfig";
import storeRTK from "../../store/storeRTK";
import {
  resetUnreadMessagesCount,
  setActiveChatUpdate,
  setHistoryfilterChatCount,
} from "../../actions/chat";
import { IndividualChat } from "../../types/chat.type";
import ChatInfo from "./ChatInfo/ChatInfo";
import {
  CannedResponses,
  IndividualCannedResponses,
} from "../../types/agent.type";
import Emitter from "../../emitter";
import { API_UNREAD_CHAT_COUNT, CHAT_ROLES } from "../../constants/constants";
import { STATE_WEBCHATMESSAGE } from "../../constants/events";
import { SessionEvent } from "../../types/call.type";
import AcceptDialog from "../common/AcceptDialog/AcceptDialog";

const ChatWebcase = () => {
  const chat = useSelector((state: RootState) => state.chat);
  const history = useSelector((state: RootState) => state.history);
  const agent = useSelector((state: RootState) => state.agent);
  const [chatDetail, setChatDetail] = useState<any>({});
  const [showChatDetail, setShowChatDetail] = useState<boolean>(true);
  const [typingStatus, setTypingStatus] = useState(false);
  const [uplodingFiles, setUploadingFiles] = useState<any>({});
  const [searchBoxOptions, setSearchBoxOptions] = useState([]);
  const [messageList, setmessageList] = useState([]);

  let setTimer: any;

  useEffect(() => {
    storeRTK.dispatch(setHistoryfilterChatCount(history?.chat?.length));
  }, []);

  useEffect(() => {
    // Emitter.on(UPDATE_AGENT_RESPONSE, updateAgentResponse);
    Emitter.on(STATE_WEBCHATMESSAGE, updateChatUnreadCount);
    // Emitter.on(TOGGLE_CHAT_STATUS_WEBCASE, toggleStatusWebcase);
    // Emitter.on(SHOW_API_STATUS_MESSAGE, removeUploadingFile);
    return () => {
      // Emitter.off(UPDATE_AGENT_RESPONSE, updateAgentResponse);
      Emitter.off(STATE_WEBCHATMESSAGE, updateChatUnreadCount);
      // Emitter.off(TOGGLE_CHAT_STATUS_WEBCASE, toggleStatusWebcase);
      // Emitter.off(SHOW_API_STATUS_MESSAGE, removeUploadingFile);
    };
  }, [chat]);

  useEffect(() => {
    const activeChat = chat.chats.find(
      (chatItem: IndividualChat) => chatItem.id === chat?.chats[0]?.id
    );
    storeRTK.dispatch(resetUnreadMessagesCount({ chatID: activeChat?.id }));
    setChatDetail(activeChat);
    const body = {
      chatID: activeChat?.id,
    };
    storeRTK.dispatch(setActiveChatUpdate(body));
  }, [chat?.chats?.length]);

  const handleActiveChatId = (id: string) => {
    const activeChat = chat.chats.find(
      (chatItem: IndividualChat) => chatItem.id === id
    );
    storeRTK.dispatch(resetUnreadMessagesCount({ chatID: activeChat?.id }));
    setChatDetail(activeChat);
    const body = {
      chatID: activeChat?.id,
    };
    storeRTK.dispatch(setActiveChatUpdate(body));
  };

  const handleShowChatDetail = () => {
    setShowChatDetail(!showChatDetail);
  };

  useEffect(() => {
    if (chatDetail) {
      updateCannedResponse();
      setTypingStatus(false);
    }
    return () => {
      setTypingStatus(false);
      setSearchBoxOptions([]);
      setmessageList([]);
    };
  }, [chat.activeChatID, chatDetail?.self?.state]);

  const updateChatUnreadCount = (message: SessionEvent<any>) => {
    let { body } = message;
    let { webChatConversation } = body;
    let { id } = webChatConversation;
    const activeChatId = chat.chats.findIndex(
      (ele: IndividualChat) => ele.id === chat.activeChatID
    );
    if (
      body.body === undefined &&
      body.role === CHAT_ROLES.CUSTOMER &&
      chat.activeChatID === id
    ) {
      setTypingStatus(true);
      if (setTimer !== undefined) {
        clearTimeout(setTimer);
      }

      setTimer = setTimeout(() => {
        setTypingStatus(false);
      }, 3000);
    }

    if (body.body && body.role === CHAT_ROLES.CUSTOMER) {
      setTypingStatus(false);

      if (chat?.chats[activeChatId]?.id !== id) {
        Emitter.emit(API_UNREAD_CHAT_COUNT, {
          body: {
            chatID: id,
            messageCount: 0,
          },
        });
      } else {
        const filteredChat = chat?.chats.find(
          (chat: IndividualChat) => chat.id === id
        );
        if (filteredChat) {
          const msgCount =
            filteredChat.unreadMessages !== undefined
              ? filteredChat.unreadMessages + 1
              : 1;
          Emitter.emit(API_UNREAD_CHAT_COUNT, {
            body: {
              chatID: id,
              messageCount: msgCount,
            },
          });
        }
      }
    }
  };

  const updateCannedResponse = () => {
    // take the canned response entry and generate search box options as well as message list
    if (chatDetail && chatDetail.id) {
      let responsesArray = (agent?.cannedResponses || []).flatMap(
        (item: CannedResponses) => item.responses
      );
      let category = new Set();
      let messageListObject: any = [];
      let searchBoxValueObject: any = [];
      let initialIndex = 1;
      if (responsesArray) {
        responsesArray.forEach(function (
          item: IndividualCannedResponses,
          index: number
        ) {
          category.add(item.category);
          messageListObject.push({
            id: index + 1,
            name: item.title,
            content: item.content,
          });
        });
      }
      category.forEach(function (value) {
        searchBoxValueObject.push({
          id: initialIndex++,
          name: value,
        });
      });
      setSearchBoxOptions(searchBoxValueObject);
      setmessageList(messageListObject);
    }
  };

  return (
    <>
      {chat?.chats?.length > 0 && (
        <Flex direction={"row"} width={"100%"} height={"100%"}>
          <View
            backgroundColor="static-white"
            width={"20%"}
            borderEndWidth={"thick"}
            borderEndColor={"gray-200"}
          >
            <ChatList
              chat={chat.chats}
              activeChatId={chatDetail?.id}
              handleActiveChatId={handleActiveChatId}
            />
          </View>
          <Flex direction={"row"} width={"100%"}>
            <Flex direction={"column"} width={"68.4%"}>
              <View backgroundColor="static-white">
                <ChatHeader
                  showChatDetail={showChatDetail}
                  chatDetail={chatDetail}
                  handleShowChatDetail={handleShowChatDetail}
                  activeChatId={chatDetail?.id}
                />
              </View>
              {/* {showChatDetail && (
                <View backgroundColor="static-white">
                  <ChatDetails chatDetail={chatDetail} />
                </View>
              )} */}
              <View
                backgroundColor="static-white"
                UNSAFE_className="chat-transcript-container"
              >
                <ChatTranscript
                  chatType={"liveChat"}
                  key={chat.activeID}
                  typingStatus={typingStatus}
                  uplodingFiles={uplodingFiles}
                  setUploadingFiles={setUploadingFiles}
                  activeChatId={chatDetail?.id}
                />
              </View>
              <View backgroundColor="static-white">
                <ChatFooter
                  uplodingFiles={uplodingFiles}
                  setUploadingFiles={setUploadingFiles}
                  activeChatId={chatDetail?.id}
                />
              </View>
            </Flex>
            <View width={"31.6%"} UNSAFE_className="chatinfo-container">
              <ChatInfo isLiveChat={true} isHistory={false} activeChatId={chatDetail?.id}/>
            </View>
          </Flex>
        </Flex>
      )}

      {!chat?.chats?.length && <ChatDefaultPage />}
      <AcceptDialog type="chat" />
    </>
  );
};

export default ChatWebcase;
